export default __webpack_public_path__ + "static/media/hotel-box-3.4fd66b39.jpg";